import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import { useAppDispatch } from 'features/app/hooks';
import { updateSipConfig } from 'features/environment/helpers';
import {
  EnvironmentDaoService,
  EnvironmentService,
} from 'features/environment/services';
import { handleError } from 'features/notification/store';

export const EnvironmentConfig: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch();
  const [isConfigLoading, setIsConfigLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const setEnvironmentConfig = async () => {
      try {
        const environmentConfig =
          await EnvironmentDaoService.getPreLoginEnvironmentConfig();
        if (environmentConfig && isMounted) {
          EnvironmentService.setConfig(environmentConfig);

          if ('sip' in environmentConfig) {
            updateSipConfig({ sip: environmentConfig.sip });
          }
        }
      } catch (error) {
        if (isMounted) {
          dispatch(handleError({ error, methodName: 'setEnvironmentConfig' }));
        }
      } finally {
        if (isMounted) {
          setIsConfigLoading(false);
        }
      }
    };
    setEnvironmentConfig();
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  if (isConfigLoading) {
    return <div>Loading configuration...</div>;
  }

  return <>{children}</>;
};
